import { render, staticRenderFns } from "./ProductSectorsModal.vue?vue&type=template&id=42c0cc32&scoped=true&"
import script from "./ProductSectorsModal.vue?vue&type=script&lang=ts&"
export * from "./ProductSectorsModal.vue?vue&type=script&lang=ts&"
import style0 from "./ProductSectorsModal.vue?vue&type=style&index=0&id=42c0cc32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c0cc32",
  null
  
)

export default component.exports